import { motion } from 'framer-motion';
import { NEONVERSE } from '../constants';

const fadeUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: '-80px' },
  transition: { duration: 0.55 },
};

const NeonAbout = () => (
  <section className="nv-section nv-about" id="about">
    <div className="nv-container nv-split">
      <motion.div {...fadeUp}>
        <p className="nv-eyebrow">About</p>
        <h2 className="nv-title">About Neon Verse Studio</h2>
        {NEONVERSE.about.map((para) => (
          <p key={para.slice(0, 32)} className="nv-body">
            {para}
          </p>
        ))}
        <p className="nv-body">
          Neon Verse Studio is based in{' '}
          <span className="nv-about__place">{NEONVERSE.location} — Music City</span>
          . We craft personalized songs with the care and craft this city&apos;s music culture is
          known for.
        </p>
      </motion.div>

      <motion.div
        style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 0.55, delay: 0.1 }}
      >
        <div className="nv-mission-block">
          <h3>Our Mission</h3>
          <p>{NEONVERSE.mission}</p>
        </div>
        <div className="nv-mission-block">
          <h3>Our Vision</h3>
          <p>{NEONVERSE.vision}</p>
        </div>
      </motion.div>
    </div>
  </section>
);

export default NeonAbout;
